import { ToastContainer } from 'react-toastify';
const HeaderMobile = () => {

    return (
        <>
            <ToastContainer />
        </>
    )
}

export default HeaderMobile;